<template>
  <transition name="slide-fade">
    <div class="page page-your-kits" v-if="user">
      <div class="container">
        <header>
          <div class="row">
            <h1 class="col-md-8">
              <span >My Research</span>
            </h1>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="page-description">
                Welcome to the start of your journey to contribute to important microbiome-related research. In this section of the portal, you can keep track of your research kits, redeem new kits and, if relevant to your study, you can complete questionnaires and view your results.
              </div>
            </div>
          </div>
        </header>

        <template v-if="kits" v-for="project in kits">
          <div class="row">
            <div class="col-12">
              <div class="projectTitle clearfix">
                <div class="pull-left">
                  <div class="title">{{ project.name }}</div>
                  <div class="detail">{{ project.contactName }}</div>
                  <div class="detail">Phone: {{ project.phone }}</div>
                  <div class="detail">Email: {{ project.email }}</div>
                </div>
                <div class="action pull-right">
                  <!--<a @click.prevent="redeemCode" class="btn btn-outline-secondary">Redeem kit</a>-->
                </div>
              </div>

            </div>

          </div>

          <ul class="list-group">
            <KitItem v-for="kit in project.kits"
                    :project="project"
                    :kit="kit" :key="kit.id"
                    :showCoach="false"
                    :showReferralCode="false"
                    :allowGive="false"
                    :overrideStatuses="getKitStatuses(project, kit)"
                    baseStatus="Kit Activated"
                    @onClickRedeem="onClickRedeem(kit.id, project)"
                    @onClickActivate="onClickActivate(kit.id, project)"
                    @onClickRequest="onClickRequest(kit.id, project)"
                    @onClickSend="onClickSend(kit.id, project)"
                    @onClickBook="onClickBook(kit.id)"
                    @onClickReplacement="onClickReplacement(kit.id)"
                    @onClickCoachInfo="showCoachInfoModal = true" />
            <LoadingKitItem v-if="orderProcessing" />
            <NoKits v-if="kits.length < 1" />
          </ul>
        </template>

        <ul class="list-group buy-buttons" v-if="user">
          <div class="list-group-item">
            <div class="row">
              <div class="col-md-6 col-12 text-right pt-2 pb-2">
                <button class="btn btn-primary pl-5 pr-5" @click.prevent="redeemCode()">Activate a new kit</button>

              </div>
              <div class="col-md-6 col-12 text-left pt-2 pb-2">
                <button class="btn btn-primary pl-5 pr-5" @click.prevent="addProject()">Join a new project</button>
              </div>

            </div>
          </div>
        </ul>



      </div>

      <ModalActivate :kitID="selectedKit" :show="showActivatModal" @close="showActivatModal = false" />

      <ModalAddProject
        :show="showAddProjectModal"
        @close="showAddProjectModal = false"
        @activateKit="onClickActivate"
      ></ModalAddProject>
      <ModalRedeemKit
        :show="showRedeemKitModal"
        @close="showRedeemKitModal = false"
        @activateKit="onClickActivate"
      ></ModalRedeemKit>

      <h1 v-if="orderProcessing">LOADING</h1>
    </div>
  </transition>
</template>

<script>
import KitItem from '@/components/elements/KitItem'
import NoKits from '@/components/elements/noKits'
import LoadingKitItem from '@/components/elements/LoadingKitItem'
import { StripeCheckout, Bus } from 'vue-stripe'
import PurchaseKit from '@/mixins/purchaseKits'
import ModalActivate from '@/application/research/models/ModalActivate'
import ModalSendAKit from '@/components/models/ModalSendAKit'
import ModalAddProject from '@/application/research/models/ModalAddProject'
import ModalRedeemKit from '@/application/research/models/ModalRedeemKit'
import PaymentButton from '@/components/elements/PaymentButton'

export default {
  mixins: [ PurchaseKit ],
  components: {
    KitItem,
    NoKits,
    LoadingKitItem,
    ModalSendAKit,
    PaymentButton,
    ModalActivate,
    ModalAddProject,
    ModalRedeemKit,
    Bus,
    'stripe-checkout': StripeCheckout
  },
  data: () => {
    return {
      activeTab: 0,
      showSendModal: false,
      showActivatModal: false,
      showRedeemModal: false,
      showAddProjectModal: false,
      showRedeemKitModal: false,
      redeemStartStep: 'REDEEM_CODE',
      showOrderModal: false,
      showGiveModal: false,
      showBookingModal: false,
      showCoachInfoModal: false,
      showReplacementModal: false,
      selectedKit: '',
      selectedProject: null,
      replacementKitProduct: {
        amount: Number(process.env.PRICE_REPLACEMENT_KIT) || 30.00,
        label: '1 Microba insight kit',
        orderType: 'REPLACEMENT'
      },
      additionalKit: {
        amount: Number(process.env.PRICE_NEW_KIT) || 419.00,
        label: '1 Microba insight kit',
        orderType: 'NEW'
      },
      selectedProduct: this.tempProduct
    }
  },
  mounted: function () {
    this.$store.dispatch('getUser')
    this.$store.dispatch('getResearchKits')
  },
  computed: {
    loading: function () {
      return this.$store.state.GET_KITS_PENDING
    },
    kits: function () {
      return this.$store.state.GET_KITS_RESPONSE || []
    },
    sentKits: function () {
      return this.$store.state.GET_SENT_KITS_RESPONSE || []
    },
    user: function () {
      return this.$store.state.GET_USER_RESPONSE
    },
    orderProcessing: function () {
      return false // this.$store.state.processing.order
    },
    addKitText: function () {
      return 'Buy a kit for my journey'
    },
    selectedKitId () {
      return this.selectedKit.kitId
    }
  },

  methods: {
    getKitStatuses (project, kit) {
      let rsp = null
      if (project.logisticType === 'MICROBA_MANAGED') {
        rsp = {
          REQUESTED: 'Preparing your order',
          DISPATCHED: 'Your kit has been dispatched',
          RECEIVED_BY_LAB: 'Sample received by Microba'
        }
      } else {
        rsp = {
          REQUESTED: 'Sampling',
          DISPATCHED: false,
          RECEIVED_BY_LAB: 'Received by Microba'
        }
      }

      if (project.resultDeliveryType !== 'NO_DELIVERY' && project.resultDeliveryType !== '') {
        rsp.RESULTS_AVAILABLE = 'Results Available'
      }

      return rsp
    },
    addProject () {
      this.showAddProjectModal = true
    },
    redeemCode () {
      this.showRedeemKitModal = true
    },
    showOrderForMe () {
      this.showGiveModal = false
      this.showOrderModal = true
    },
    showOrderForSomeone () {
      this.showGiveModal = true
      this.showOrderModal = true
    },
    onClickRedeem: function (kitID, obj) {
      this.selectedKit = kitID
      this.selectedProject = obj
      this.showRedeemModal = true
    },
    onClickSend: function (kitID, obj) {
      this.selectedKit = kitID
      this.selectedProject = obj
      this.showSendModal = true
    },
    onClickActivate: function (kitID, obj) {
      this.selectedKit = kitID
      this.selectedProject = obj
      this.showActivatModal = true
    },
    onClickRequest: function (kitID, obj) {
      this.selectedKit = kitID
      this.selectedProject = obj
      this.showActivatModal = true
    },
    onClickBook: function (kitID) {
      this.selectedKit = kitID
      this.showBookingModal = true
    },
    onClickReplacement: function (kitID) {
      this.selectedKit = kitID
      this.showReplacementModal = true
    },
    showPurchaseModal: function (product) {
      this.selectedProduct = product
      this.showOrderModal = true
    }
  },

  name: 'yourKits'
}
</script>

<style scoped>
.list-group{
  margin-bottom: 2rem;
}
.list-group-item{
  padding-bottom: 0.5rem;
}

.page-description {
  color: #00193D;
  font-size:1rem;
}
.buy-buttons .list-group-item{
  background: #EEF0F2;
}
.buy-buttons .list-group-item .row{
max-width: 860px;
margin: 0px auto;
}

.projectTitle{
  background: #41587a;
  color: #fefffb;
  padding: 20px;
  border-radius: 5px;
  margin: 10px 0;
}
.projectTitle .title{
  font-size:20px;
  font-weight:400
}
.projectTitle .detail{
  font-size:14px;
}
.projectTitle .action .btn{

  margin-top: 20px;
  border-color: #fff;

}

</style>



// WEBPACK FOOTER //
// src/application/research/YourKits.vue